var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg-icon',{staticClass:"scroll-to-top",class:_vm.modifierClasses,attrs:{"name":"arrow_circle_up"},on:{"click":_vm.scrollToTop}})}
var staticRenderFns = []

export { render, staticRenderFns }